import React from 'react';
import { withRouter } from 'react-router-dom';

import UsersTableList from 'components/UsersTableList';
import Layout from 'components/Layout';

const UsersList = ({ history }) => {
  return (
    <Layout title="Employees">
      <UsersTableList
        type="employee"
        path="employees"
        title="Employees"
        history={history}
        isCustomer={false}
      />
    </Layout>
  );
};

export default withRouter(UsersList);
